import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@6.0.9@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "down",
  "use": "down-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"down\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 1H2a1 1 0 00-1 1v7.85h12V2a1 1 0 00-1-1zM0 9.85V12a2 2 0 002 2h10a2 2 0 002-2V2a2 2 0 00-2-2H2a2 2 0 00-2 2v7.85zM13 12v-1.15H1V12a1 1 0 001 1h10a1 1 0 001-1zM3.854 3.496a.5.5 0 10-.708.708l3.5 3.5a.5.5 0 00.708 0l3.5-3.5a.5.5 0 00-.708-.708L7 6.643 3.854 3.496z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id